import React, { PureComponent } from 'react';
import { withApollo } from 'react-apollo';
import ConfirmationModal from 'components/ConfirmationModal';

class GraphQLErrorMessageModal extends PureComponent {
  state = {
    messageQueue: []
  };

  componentDidMount() {
    this.props.client.addGraphQLErrorListener(this.handleGraphQLError);
  }

  componentWillUnmount() {
    this.props.client.removeGraphQLErrorListener(this.handleGraphQLError);
  }

  handleGraphQLError = graphQLErrors => {
    graphQLErrors.forEach(error => {
      const displayMessage = error.extensions?.displayMessage;
      if (displayMessage) {
        this.pushMessage(displayMessage);
      }
    });
  };

  handleCloseMessage = () => {
    this.popMessage();
  };

  pushMessage(displayMessage) {
    const { messageQueue } = this.state;
    if (!messageQueue.includes(displayMessage)) {
      this.setState({
        messageQueue: messageQueue.concat(displayMessage)
      });
    }
  }

  popMessage() {
    const { messageQueue } = this.state;
    if (messageQueue.length) {
      this.setState({
        messageQueue: messageQueue.slice(1)
      });
    }
  }

  render() {
    const { messageQueue } = this.state;

    if (!messageQueue.length) {
      return null;
    }

    return (
      <ConfirmationModal
        onSelection={this.handleCloseMessage}
        cancelText="Close"
        show={true}
        title="Alert"
      >
        {messageQueue[0]}
      </ConfirmationModal>
    );
  }
}

export default withApollo(GraphQLErrorMessageModal);
